import { FC, useEffect, useState } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers';
import { acceptExperienceInvitation, approveExperience, getDurations, getRequestExperiences, rejectExperience, rejectExperienceInvitation } from '../../../services/teamExperienceService';
import { ExperienceOnRequest } from '../../teamExperiences/models/ExperienceSummaryModel';
import { GenericModel } from '../../teamExperiences/models/GenericModel';
import Pagination from '../../components/Pagination';
import { useHistory } from 'react-router-dom';
import { EXPERIENCE_STATUS, EXPERIENCE_STATUS_LIST } from '../../teamExperiences/models/ExperienceStatus';
import { DeclineReasonsModal } from '../../partnerExperiences/components/DeclineReasonsModal';
import GuestsPopover from './GuestsPopover';
import { useConfirmAction } from '../../../hooks/utils/useConfirmAction';
import { LoaderOverlay } from '../../../hooks/loader/LoaderOverlay';
import { showErrorAlert } from '../../../helpers/alert';
import { getMaxPeople } from '../../experienceHostPreview/components/utils';
import { defaultProfileImage, defaultVerticalImage } from '../../../utils/constants';
import { handleImageErrorGray } from '../../../utils/UtilsFiles';

interface PropsSectionRequest {
}

const SectionRequest: FC<PropsSectionRequest> = ({ }) => {
    const [durations, setDurations] = useState<GenericModel>([]);
    const [paginationData, setPaginationData] = useState<any>(null);
    const [listExperiences, setListExperiences] = useState<ExperienceOnRequest[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [openOverlay, setOpenOverlay] = useState(true);
    // modal declinar
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(0);
    const limit = 5;
    const history = useHistory()
    const confirm = useConfirmAction()

    useEffect(() => {
        const fetchData = async () => {
            const duration = await getDurations();
            setDurations(duration.results);
            await getList();
        }
        fetchData();
    },[])

    const getList = async (page:number=1,offset:number=0) => {
        setIsLoading(true);
        const experiences = await getRequestExperiences({ limit, offset, status: 'pending' });
        setPaginationData(experiences);
        const items = experiences?.results?.results || experiences?.results || [];
        setListExperiences(Array.isArray(items) ? items : []);
        setCurrentPage(page);
        setIsLoading(false);
    }

    const totalPages = paginationData
        ? Math.ceil((paginationData.count || 0) / limit)
        : 1;

    const handlePageChange = async (page: number) => {
        const offset = (page - 1) * limit;
        await getList(page,offset);
    };

    const handleReject = async (id: number) => {
        let accept = await confirm({ title: 'Reject', message: 'Do you want to decline this booking request?', btnTextAction: 'Reject' });
        if(accept){
            let isReject = await rejectExperienceInvitation(id);
            if(isReject){
                showErrorAlert({title:'Declined',message:'The booking request has been declined.'})
                await getList(1,0);
            }
        }
    }

    const handleAccept = async (id: number) => {
        let accept = await confirm({ title: 'Accept', message: 'Do you want to accept this booking request and process payment?' });
        if(accept){
            let isAprroved = await acceptExperienceInvitation(id);
            if(isAprroved){
                showErrorAlert({title:'Accepted',message:'The booking request has been accepted successfully.'})
                await getList(1,0);
            }
        }
    }

    return (
        <div className="tap-host-secction-experiences-past-wrapper">
            <div className={`tap-host-secction-experiences-past-list ${isLoading ? '' : 'd-none'}`}>
                <div className='loader-experience'></div>
            </div>
            <div className={`tap-host-secction-experiences-past-list`}>
                {(listExperiences ?? []).map((exp: any, index:number) => {
                    const isInvitation = Boolean(exp.is_invitation || exp.type === 'invitation' || exp.status === 'invitation');
                    const displayUser = isInvitation ? (exp.host || exp.user) : (exp.user || exp.host);
                    const expId = exp.experience_id || exp.experienceId || exp.id;
                    const capacityMax = exp.guestCapacity?.max ?? exp.guests_count ?? 1;

                    return (
                    <div key={exp.id ?? index} className="tap-host-secction-experiences-past-card-2">

                        {/* LEFT IMAGE */}
                        <div className="tap-host-secction-experiences-past-img-wrapper tap-flex-center cursor-pointer" onClick={()=>history.push('/experience/detail/'+expId)}>
                            <img className="tap-host-secction-experiences-past-img" src={exp.image ?? ''} onError={handleImageErrorGray} alt={exp.title}/>

                            <div className="tap-host-secction-experiences-past-img-overlay">
                                <div className="tap-host-secction-experiences-past-img-title">
                                    {exp.title}
                                </div>
                            </div>
                        </div>

                        {/* RIGHT CONTENT */}
                        <div className="tap-host-secction-experiences-past-details">

                            {/* HOST / REQUESTER */}
                            <div className="tap-host-secction-experiences-past-host-group cursor-pointer justify-content-between">
                                <div className="tap-host-secction-experiences-past-host" onClick={()=>history.push('/experience/detail/'+expId)}>
                                    <img src={displayUser?.profilePicture ?? defaultProfileImage} onError={(e) => {e.currentTarget.src = defaultProfileImage;}} className="tap-host-secction-experiences-past-host-img" alt={exp?.title} />
                                    <div className="tap-host-secction-experiences-past-host-name">
                                        {isInvitation ? `Host: ${displayUser?.firstName ?? ''} ${displayUser?.lastName ?? ''}` : `${displayUser?.firstName ?? ''} ${displayUser?.lastName ?? ''}`}
                                    </div>
                                </div>
                                <div className="tap-host-secction-experiences-past-info-item">
                                    <div className="tap-host-secction-experiences-past-icon icon-user">
                                        <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_person.svg' />&nbsp;
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-text">
                                        Guests
                                    </div>
                                </div>
                                <div className="tap-host-secction-experiences-past-info-text text-end text-capitalize">
                                    { isInvitation ? 'Invitation' : exp.status }
                                </div>
                            </div>

                            {/* INFO BOX */}
                            <div className="tap-host-secction-experiences-past-info-box cursor-pointer" onClick={()=>history.push('/experience/detail/'+expId)}>
                                <div className="tap-host-secction-experiences-past-info-row w-100">
                                    <div className="tap-host-secction-experiences-past-info-text w-25">
                                        Topic
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-text w-75">
                                        {exp?.topic || exp?.title}
                                    </div>
                                </div>
                                <div className="border-bottom-line"></div>
                                <div className="tap-host-secction-experiences-past-info-row w-100">
                                    <div className="tap-host-secction-experiences-past-info-text w-25">
                                        Message
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-text w-75">
                                        {exp?.message || 'No message provided'}
                                    </div>
                                </div>
                            </div>

                            {/* BOTTOM ACTIONS */}
                            {!isInvitation && exp.status == 'pending' && (<div className="tap-host-secction-experiences-past-actions">
                                <div className="tap-host-secction-experiences-past-buttons">
                                    <div role='button' onClick={() => handleReject(exp.id)} className={`tap-add-experience-2-btn-secondary`}>
                                        Reject
                                    </div>
                                </div>
                                <div className="tap-host-secction-experiences-past-buttons">
                                    <div role='button' onClick={() => handleAccept(exp.id)} className="tap-add-experience-2-btn-main tap-flex-center">
                                        <div className='tap-host-button-text tap-flex-center'>
                                            Accept
                                            &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                                        </div>
                                    </div>
                                </div>
                            </div>)}

                            {isInvitation && (<div className="tap-host-secction-experiences-past-actions">
                                <div className="tap-host-secction-experiences-past-buttons">
                                    <div role='button' onClick={()=>history.push('/experience/detail/'+expId)} className="tap-add-experience-2-btn-main tap-flex-center">
                                        <div className='tap-host-button-text tap-flex-center'>
                                            View Experience
                                            &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                                        </div>
                                    </div>
                                </div>
                            </div>)}

                            {!isInvitation && exp.status != 'pending' && (<div className="tap-host-secction-experiences-past-actions">
                                &nbsp;
                            </div>)}
                        </div>
                    </div>)
                })}
            </div>
            {listExperiences.length > 0 && paginationData && (<div className='text-start mt-5'>
                <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
            </div>)}
            {listExperiences.length == 0 && (<div className="tap-host-secction-experiences-past-img-title justify-content-start text-dark">
                No experiences available.
            </div>)}
            {selectedItem > 0 && (<DeclineReasonsModal experienceId={selectedItem} open={showDeclineModal} onCancel={()=>setShowDeclineModal(false)} />)}
            <LoaderOverlay visible={isLoading} message={'Loading...'} />
        </div>

    )
}

export { SectionRequest }